const e = {
  getAsset: {
    schema: {
      method: "get",
      url: "/assets/{id}"
    }
  }
};
export {
  e as assetsService
};
